import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function ReframeSection() {
  return <section className="py-20 px-4 bg-cream-200" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-87">
            Por qué lo que intentaste no funcionó
          </h2>
          <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-88">
            Estabas tratando la hinchazón como si fuera un problema de{' '}
            <strong data-id="element-89">fuerza de voluntad</strong>. O como si fuera un problema de
            "come menos".
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-91">
            <div className="flex items-center gap-3 mb-6 text-red-400" data-id="element-92">
              <XCircle size={24} data-id="element-93" />
              <h3 className="text-xl font-bold text-brown" data-id="element-94">El error común</h3>
            </div>
            <p className="text-brown-light mb-4" data-id="element-95">
              Cuando cambias 20 cosas a la vez:
            </p>
            <ul className="space-y-3 text-brown-light" data-id="element-96">
              <li className="opacity-70" data-id="element-97">• No sabes qué te ayudó</li>
              <li className="opacity-70" data-id="element-98">• No sabes qué te infló</li>
              <li className="opacity-70" data-id="element-99">• Te cansas</li>
              <li className="opacity-70" data-id="element-100">• Lo dejas</li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-101">
            <div className="flex items-center gap-3 mb-6 text-sage-dark" data-id="element-102">
              <CheckCircle2 size={24} data-id="element-103" />
              <h3 className="text-xl font-bold text-brown" data-id="element-104">La verdad</h3>
            </div>
            <p className="text-brown mb-4 font-medium" data-id="element-105">
              La hinchazón casi siempre es un problema de{' '}
              <strong data-id="element-106">ritmo + detonantes + caos</strong>.
            </p>
            <p className="text-brown-light" data-id="element-107">
              No es falta de disciplina. Es falta de un sistema pequeño y
              medible. Necesitas un <strong data-id="element-108">reset corto</strong> que funcione en
              tu vida real.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}